import './index.scss'
import { useChapters } from './../../js/useChapters'

class Summary {
  constructor(el) {
    this.$el = el
  }
  init() {
      useChapters(this.$el, this.$el.querySelector('.oce-summary__swiper'))
  }
}

document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.oce-summary')).forEach($block => {
        $block.expandygg = new Summary($block)
    })
}, {capture: false, passive: true, once: true} || false)